import { z } from 'zod';
import { Api, ApiFilterBuilder } from '@automapa/svelte-automapa-template';
import { type QueriesType, QueriesTypeSchema } from '../../components/telematics/types';

export const WidgetTemplateRequestSchema = z.object({
    label: z.string(),
    user_private: z.boolean(),
});
export type WidgetTemplateRequestType = z.infer<typeof WidgetTemplateRequestSchema>;

export const WidgetTemplateResponseSchema = WidgetTemplateRequestSchema.merge(
    z.object({
        id: z.number(),
        webuser_id: z.number().nullable(),
        webuser_name: z.string().catch('webuser_name is not defined'),
    })
);
export type WidgetTemplateResponseType = z.infer<typeof WidgetTemplateResponseSchema>;

export class WidgetTemplateApi {
    public static async create(
        api: Api,
        cr: WidgetTemplateRequestType
    ): Promise<WidgetTemplateResponseType> {
        return api.getData<WidgetTemplateRequestType, WidgetTemplateResponseType>(
            'post',
            '/dashboard_template',
            cr,
            WidgetTemplateRequestSchema,
            WidgetTemplateResponseSchema
        );
    }

    public static async getAll(
        api: Api,
        filter: ApiFilterBuilder,
        webuser_id: number | null
    ): Promise<WidgetTemplateResponseType[]> {
        let q = {};
        if (webuser_id !== null) {
            q = { $or: [{ webuser_id: webuser_id }, { user_private: false }] };
        }
        return this.filter(api, filter, q);
    }

    public static async remove(api: Api, id: number): Promise<void> {
        return api.delete(`/dashboard_template/${id}`);
    }

    public static async filter(
        api: Api,
        filter: ApiFilterBuilder,
        query: QueriesType
    ): Promise<WidgetTemplateResponseType[]> {
        return api.getData<QueriesType, WidgetTemplateResponseType[]>(
            'post',
            '/dashboard_template/query' + filter.getUri(),
            query,
            QueriesTypeSchema,
            z.array(WidgetTemplateResponseSchema)
        );
    }

    public static async modify(
        api: Api,
        id: number,
        cr: WidgetTemplateRequestType
    ): Promise<WidgetTemplateResponseType> {
        return api.getData<WidgetTemplateRequestType, WidgetTemplateResponseType>(
            'put',
            `/dashboard_template/${id}`,
            cr,
            WidgetTemplateRequestSchema,
            WidgetTemplateResponseSchema
        );
    }
}
